const MyFooter = () =>{
    return (
        <a href={'https://beian.miit.gov.cn'} target='_blank' rel='noopener noreferrer'>渝ICP备19006914号-1</a>
    )
}

export default MyFooter